import { render, staticRenderFns } from "./studentCalendar.vue?vue&type=template&id=ebe28d18&scoped=true&"
import script from "./studentCalendar.vue?vue&type=script&lang=ts&"
export * from "./studentCalendar.vue?vue&type=script&lang=ts&"
import style0 from "./studentCalendar.vue?vue&type=style&index=0&id=ebe28d18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe28d18",
  null
  
)

export default component.exports